import { render, staticRenderFns } from "./AddSubscriptionPlanModal.vue?vue&type=template&id=f31b1968&scoped=true&"
import script from "./AddSubscriptionPlanModal.vue?vue&type=script&lang=ts&"
export * from "./AddSubscriptionPlanModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddSubscriptionPlanModal.vue?vue&type=style&index=0&id=f31b1968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31b1968",
  null
  
)

export default component.exports